import { render, staticRenderFns } from "./LoveGuru.vue?vue&type=template&id=9ade381c&scoped=true"
var script = {}
import style0 from "./LoveGuru.vue?vue&type=style&index=0&id=9ade381c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ade381c",
  null
  
)

export default component.exports